export const environment = {
    BaseUrl: "https://api.oevent.net",
    ChatSocketUrl: "wss:/api.oevent.net/chat-ws",
    SocketUrl: "wss:/api.oevent.net/notification-ws",
    thawaniPaymentUrl: "https://checkout.thawani.om"
}
export const googleMapsApiKey = "AIzaSyAmpmxk6VmELQyseSzK_OM1aOUkktYobus";
export const thawaniPayment_publishable_key = "mfgP0UorfSxuGGbQJaL43Dfu5Yiba1"
